import { render, staticRenderFns } from "./view-activity-details.vue?vue&type=template&id=d0ba3232"
import script from "./view-activity-details.vue?vue&type=script&lang=js"
export * from "./view-activity-details.vue?vue&type=script&lang=js"
import style0 from "./view-activity-details.vue?vue&type=style&index=0&id=d0ba3232&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports